import {Injectable} from '@angular/core';
import {NzNotificationService} from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private showNotifications = true;

  setShowNotifications(show: boolean): void {
    this.showNotifications = show;
  }

  getShowNotifications(): boolean {
    return this.showNotifications;
  }

  constructor(private notification: NzNotificationService) {
  }

  createNotification(type: 'success' | 'error' | 'warning' | 'info', title: string, content: string): void {
    if (this.showNotifications) {
      this.notification.create(
        type,
        title,
        content
      );
    }
  }

  error(content: string, title: string = 'Lỗi'): void {
    this.createNotification('error', title, content);
  }


  warning(content: string, title: string = 'Chú ý'): void {
    this.createNotification('warning', title, content);
  }

  success(content: string, title: string = 'Thành công'): void {
    this.createNotification('success', title, content);
  }

  info(content: string, title: string = 'Thông tin'): void {
    this.createNotification('info', title, content)
  }


}
